import { useState } from 'react';
import PropTypes from 'prop-types';
import { Phone } from 'lucide-react';
import { FaWhatsapp } from 'react-icons/fa';

const ContactWidget = ({
  whatsappNumber = process.env.REACT_APP_WHATSAPP_NUMBER || '6268558700',
  phoneNumber = process.env.REACT_APP_PHONE_NUMBER || '+916268558700',
  whatsappMessage = 'Hello! I would like to get in touch regarding thesis & paper research services.',
  className = '',
  showWhatsApp = true,
  showPhone = true,
}) => {

  const [clicked, setClicked] = useState('');

  return (
    <div
      className={`fixed bottom-6 right-6 z-50 flex flex-col space-y-4 ${className}`}
    >
      {/* WhatsApp Button */}
      {showWhatsApp && (
        <div className='relative'>
          <a
            href={`https://wa.me/${whatsappNumber}?text=${encodeURIComponent(whatsappMessage)}`}
            target='_blank'
            rel='noopener noreferrer'
            onClick={() => {
              setClicked('whatsapp');
              setTimeout(() => setClicked(''), 200);
            }}
            className={`text-white p-3.5 rounded-full shadow-xl transition-all duration-300 transform hover:scale-110 cursor-pointer flex items-center justify-center ${
              clicked === 'whatsapp' ? 'scale-95' : ''
            }`}
            style={{
              backgroundColor: '#25D366',
              boxShadow: '0 4px 15px rgba(37, 211, 102, 0.45)',
            }}
            title='Chat on WhatsApp'
          >
            <FaWhatsapp className='w-7 h-7' style={{ color: '#ffffff' }} />
          </a>

          {/* Pulse animation for WhatsApp */}
          <div
            className='absolute inset-0 rounded-full animate-ping opacity-25 pointer-events-none'
            style={{ backgroundColor: '#25D366' }}
          ></div>
        </div>
      )}

      {/* Phone Button */}
      {showPhone && (
        <div className='relative'>
          <a
            href={`tel:${phoneNumber}`}
            onClick={() => {
              setClicked('phone');
              setTimeout(() => setClicked(''), 200);
            }}
            className={`text-white p-4 rounded-full shadow-lg transition-all duration-300 transform hover:scale-110 cursor-pointer flex items-center justify-center ${
              clicked === 'phone' ? 'scale-95' : ''
            }`}
            style={{
              backgroundColor: '#2563eb',
              boxShadow: '0 4px 15px rgba(37, 99, 235, 0.4)',
            }}
            title='Call Now'
          >
            <Phone className='w-6 h-6' style={{ color: '#ffffff' }} />
          </a>

          {/* Pulse animation for Phone */}
          <div
            className='absolute inset-0 rounded-full animate-ping opacity-20 pointer-events-none'
            style={{ backgroundColor: '#2563eb' }}
          ></div>
        </div>
      )}
    </div>
  );
};

ContactWidget.propTypes = {
  whatsappNumber: PropTypes.string,
  phoneNumber: PropTypes.string,
  whatsappMessage: PropTypes.string,
  className: PropTypes.string,
  showWhatsApp: PropTypes.bool,
  showPhone: PropTypes.bool,
};

ContactWidget.defaultProps = {
  whatsappNumber: process.env.REACT_APP_WHATSAPP_NUMBER || '6268558700',
  phoneNumber: process.env.REACT_APP_PHONE_NUMBER || '+916268558700',
  whatsappMessage: 'Hello! I would like to get in touch regarding thesis & paper research services.',
  className: '',
  showWhatsApp: true,
  showPhone: true,
};


export default ContactWidget;
